import React from 'react';
import { NavLink } from 'react-router-dom';
import moment from 'moment';

import VisitInfo from '../Visits/info';

export default function VisitsListV2({ skeletonItems, detailsMap, loadingProviders, user }) {
  return skeletonItems.map((skeleton) => {
    const full = detailsMap[skeleton.id];
    const isProviderLoading = loadingProviders.has(skeleton.provider_id);

    if (full) {
      return (
        <li className="personal-visits-list__item" key={skeleton.id}>
          <VisitInfo {...full} user={user} />
          <NavLink to={`/office/visits/${full.id}`} className="personal-visits-list__item-detail-link">
            <span>Деталі та рекомендації</span>
            <i className="fas fa-chevron-right" />
          </NavLink>
        </li>
      );
    }

    return (
      <li className="personal-visits-list__item personal-visits-list__item--skeleton" key={skeleton.id}>
        <div className="personal-visits-list__item-about">
          <div className="visit-card">
            {/* Left col skeleton: date + hospital */}
            <div className="visit-card__col-left">
              <div className="visit-card__date">
                <div className="skeleton-line skeleton-line--sm" style={{ marginBottom: 8 }} />
                <div className="visit-card__date-value">{moment(skeleton.date).format('DD.MM.YYYY')}</div>
              </div>
              <div>
                <div className="skeleton-line skeleton-line--sm" style={{ marginBottom: 6 }} />
                {isProviderLoading ? (
                  <>
                    <div className="skeleton-line skeleton-line--lg" />
                    <div className="skeleton-line skeleton-line--md" />
                  </>
                ) : (
                  <div style={{ fontSize: 13, color: '#d0392b' }}>Помилка завантаження</div>
                )}
              </div>
            </div>

            <div className="visit-card__divider" />

            {/* Right col skeleton: doctor + diagnosis */}
            <div className="visit-card__col-right">
              <div className="visit-card__doctor">
                <div className="skeleton-circle" style={{ width: 34, height: 34 }} />
                <div style={{ flex: 1 }}>
                  <div className="skeleton-line skeleton-line--sm" style={{ marginBottom: 8 }} />
                  <div className="skeleton-line skeleton-line--md" style={{ marginBottom: 4 }} />
                  <div className="skeleton-line skeleton-line--sm" />
                </div>
              </div>
              <div className="visit-card__diagnoses">
                <div className="skeleton-line skeleton-line--sm" style={{ marginBottom: 8 }} />
                <div className="skeleton-line skeleton-line--lg" style={{ marginBottom: 4 }} />
                <div className="skeleton-line skeleton-line--md" />
              </div>
            </div>
          </div>
        </div>
      </li>
    );
  });
}
